import qs from 'querystring'

import Api from '../lib/request'
import cookie from '../lib/cookie'
import COOKIECONSTANT from '../constant/cookie'
import _ from 'underscore'
import STATUS_CODE from '../constant/status_code'
const url = COOKIECONSTANT.REQUEST_HOST
const emptyProductListData = {
  page:{
    pageNum: 0,
    total: 0,
  },
  list: [],
}
const getCategoryChildren = (data) => {
  return new Promise((resolve, reject) => {
    const queryUrl = `${url}?${qs.stringify(data)}`
    Api.get(queryUrl, {
      headers: {
        'X-Host': 'mall.category.list',
        'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN)
      }
    }).then(data => {
      if(data.status !== 0 ) {
        return reject(data.msg)
      }
      resolve(data.data)
    }, e => {
      reject(e)
    })
  })
}

const getCategoryProducts = (data) => {
  return new Promise((resolve, reject) => {
    const queryUrl = `${url}?${qs.stringify(data)}`
    Api.get(queryUrl, {
      headers: {
        'X-Host': 'mall.product.list',
        'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN)
      }
    }).then(data => {
      if(data.status === STATUS_CODE.EMPTY_LIST) {
        return resolve(emptyProductListData)
      }
      if(data.status !== 0) {
        return reject(data.msg)
      }
      resolve(data.data)
    }, e => {
      reject(e)
    })
  })
}

const getRecommendByCategory = (data) => {
  return new Promise((resolve, reject) => {
    const queryUrl = `${url}?${qs.stringify(data)}`
    Api.get(queryUrl, {
      headers: {
        'X-Host': 'mall.product.recommend',
        'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN)
      }
    }).then(data => {
      if (data.status === STATUS_CODE.EMPTY_LIST) {
        return resolve(emptyProductListData)
      }
      if(data.status !== 0) {
        return reject(data.msg)
      }
      resolve(data.data)
    }, e => {
      reject(e)
    })
  })
}
const getCategoryInfo = (data) => {
  return new Promise((resolve, reject) => {
    const queryUrl = `${url}?${qs.stringify(data)}`
    Api.get(queryUrl, {
      headers: {
        'X-Host': 'mall.category.info',
        'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN)
      }
    }).then(data => {
      if(data.status !== 0) {
        return reject(data.msg)
      }
      resolve(data.data)
    }, e => {
      reject(e)
    })
  })
}
const getCategoryBanner = (data) => {
  return new Promise((resolve, reject) => {
    const queryUrl = `${url}?${qs.stringify(data)}`
    Api.get(queryUrl, {
      headers: {
        'X-Host': 'mall.cfg.sub-category.banners',
        'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN)
      }
    }).then(data => {
      if(data.status !== 0) {
        return reject(data.msg)
      }
      resolve(data.data)
    }, e => {
      reject(e)
    })
  })
}
const getCategoryRecommend = (data) => {
    return new Promise( (resolve, reject)=> {

        let query = ''
        if(!_.isEmpty(data)){
            query = `?${qs.stringify(data)}`
        }
      let url = `${COOKIECONSTANT.REQUEST_HOST}${query}`
        // url = 'http://easymock.sdyxmall.cn/mock/5ba05c13292c034d86d87b50/mall/api/common/banner'
        Api.get(url ,{
            headers: {
                'X-Host':'mall.cfg.common-banner',
              'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN),
            }
        })
        .then((data) => {
            if(data.status !== 0) {
                return reject(data.msg)
            }
            resolve(data.data)
        },
        (e)=> {
            reject(e)
        })
    })
}
const getCategoryOptions = (data) => {
  return new Promise( (resolve, reject)=> {
    let query = ''
    if(!_.isEmpty(data)){
        query = `?${qs.stringify(data)}`
    }
    Api.get(`${url}${query}` ,{
        headers: {
          'X-Host':'mall.product.category-options',
          'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN),
        }
    })
    .then((data) => {
        if(data.status !== 0) {
            return reject(data.msg)
        }
        resolve(data.data)
    },
    (e)=> {
        reject(e)
      })
  })
}
const getCateOpProducts = (data) => {
  return new Promise( (resolve, reject)=> {
      Api.post(url, JSON.stringify(data), {
          headers: {
            'X-Host':'mall.product.option-product-list',
            'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN),
          }
      })
      .then((data) => {
        if(data.status === STATUS_CODE.EMPTY_LIST) {
          return resolve(emptyProductListData)
        }
        if(data.status !== 0) {
            return reject(data.msg)
        }
        resolve(data.data)
      },
      (e)=> {
          reject(e)
      })
  })
}

const getCategoryFitlers = (data) => {
    return new Promise( (resolve, reject)=> {

        let query = ''
        if(!_.isEmpty(data)){
            query = `?${qs.stringify(data)}`
        }
      let url = `${COOKIECONSTANT.REQUEST_HOST}${query}`

        Api.get(url ,{
            headers: {
                'X-Host':'mall.product.category.fitlers',
              'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN),
            }
        })
        .then((data) => {
            if(data.status !== 0) {
                return reject(data.msg)
            }
            resolve(data.data)
        },
        (e)=> {
            reject(e)
        })
    })
}
const filterProductList = (data) => {
  return new Promise((resolve, reject) => {

    data = JSON.stringify(data)
    let url = COOKIECONSTANT.REQUEST_HOST

    Api.post(url, data, {
        headers: {
          'X-Host': 'mall.product.filter',
          'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN),
        }
      })
      .then((data) => {
          if (data.status !== 0) {
            return reject(data)
          }
          resolve(data.data)
        },
        (e) => {
          reject(e)
        })
  })
}
// 获取过滤条件列表
const filterOptionList = (data) => {
  return new Promise( (resolve, reject)=> {
    let query = ''
    if(!_.isEmpty(data)){
        query = `?${qs.stringify(data)}`
    }
    Api.get(`${url}${query}` ,{
        headers: {
          'X-Host':'mall.product.category.filters.v2',
          'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN),
        }
    })
    .then((data) => {
        if(data.status !== 0) {
            return reject(data.msg)
        }
        resolve(data.data)
    },
    (e)=> {
        reject(e)
      })
  })
}
// 提交过滤条件
const submitFilterOption = data => {
  return new Promise((resolve, reject) => {

    data = JSON.stringify(data)
    let url = COOKIECONSTANT.REQUEST_HOST

    Api.post(url, data, {
        headers: {
          'X-Host': 'mall.product.list.v2',
          'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN),
        }
      })
      .then((data) => {
          if (data.status !== 0) {
            return reject(data)
          }
          resolve(data.data)
        },
        (e) => {
          reject(e)
        })
  })
}
const getWelfareProductList = (data) => {
  return new Promise((resolve, reject) => {

    data = JSON.stringify(data)
    let url = COOKIECONSTANT.REQUEST_HOST

    Api.post(url, data, {
      headers: {
        'X-Host': 'mall.product.welfare-product-list',
        'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN),
      }
    })
    .then((data) => {
      if (data.status !== 0) {
        return reject(data)
      }
      resolve(data.data)
    },
    (e) => {
      reject(e)
    })
  })
}
/*yeoman-template-point-1*/
export default {
  getCategoryChildren,
  getCategoryProducts,
  getRecommendByCategory,
  getCategoryInfo,
  getCategoryBanner,
  getCategoryRecommend,
  getCategoryOptions,
  getCateOpProducts,
  getCategoryFitlers,
  filterProductList,
  filterOptionList,
  submitFilterOption,
    getWelfareProductList,
/*yeoman-template-point-2*/
}
